module.exports = __webpack_public_path__ + "static/media/botao-fechar.5a34a883.svg";